import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, Input } from '@artosera/ui';
import { useCreerSelection, type CorpsSelection } from '../../api/presentation.js';
import { galerieALaction, galerieAModule } from '../../auth/sujet.js';
import { useShellContext } from '../shell/context.js';
import { ErreurPresentation } from './ErreurPresentation.js';
import styles from './Presentation.module.css';

export function NouvelleSelection({
  origine = {},
  titreInitial = '',
  accrochage = false,
  disabled = false,
}: {
  origine?: Omit<CorpsSelection, 'titre'>;
  titreInitial?: string;
  accrochage?: boolean;
  disabled?: boolean;
}) {
  const { t } = useTranslation(['presentation', 'commun']);
  const { galerieSlug, galerie } = useShellContext();
  const navigate = useNavigate();
  const creer = useCreerSelection(galerieSlug);
  const [ouverte, setOuverte] = useState(false);
  const [titre, setTitre] = useState(titreInitial);
  if (
    !galerieAModule(galerie, 'rendez-vous-client') ||
    !galerieALaction(galerie, 'presentation:read') ||
    !galerieALaction(galerie, 'presentation:write')
  )
    return null;
  return (
    <>
      <Button
        variant="secondary"
        disabled={disabled}
        onClick={() => {
          setTitre(titreInitial);
          creer.reset();
          setOuverte(true);
        }}
      >
        {t(accrochage ? 'depuisExposition' : 'nouvelle')}
      </Button>
      <Dialog
        open={ouverte}
        onOpenChange={setOuverte}
        title={t('nouvelle')}
        closeLabel={t('commun:actions.fermer')}
      >
        <form
          className={styles.formulaire}
          onSubmit={(event) => {
            event.preventDefault();
            if (!titre.trim() || creer.isPending) return;
            creer.mutate(
              { ...origine, titre: titre.trim() },
              {
                onSuccess: ({ selection }) => {
                  setOuverte(false);
                  navigate(`/${galerieSlug}/presentation/${selection.id}`);
                },
              },
            );
          }}
        >
          <label className={styles.champ}>
            {t('titreSelection')}
            <Input
              autoFocus
              required
              maxLength={200}
              value={titre}
              onChange={(event) => setTitre(event.target.value)}
            />
          </label>
          <ErreurPresentation erreur={creer.error} />
          <Button type="submit" disabled={!titre.trim()} loading={creer.isPending}>
            {t('creer')}
          </Button>
        </form>
      </Dialog>
    </>
  );
}
